import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';
import { ContasReceberParcelaGetByIdResponse } from '@shared/services/responses/financas/contas-receber-parcela-get-by-id.response';

@Injectable({
    providedIn: 'root',
})
export class ContasReceberParcelaService extends CommonService {
    private readonly apiUrl: string = environment.urlApiFinancas + 'ContasReceberParcela';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getById(idContasReceberParcela: number): Observable<ContasReceberParcelaGetByIdResponse> {
        const url = `${this.apiUrl}/idContasReceberParcela/${idContasReceberParcela}`;
        return this.httpClient
            .get<ContasReceberParcelaGetByIdResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(request: any): Observable<ReturnStruct> {
        return this.httpClient
            .put<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getArquivoContasReceberParcela(urlArquivo: string): Observable<any> {
        const params = new HttpParams().set('urlArquivo', urlArquivo);
        const url = `${this.apiUrl}/getArquivoContasReceberParcela`;
        return this.httpClient
            .get<any>(url, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }
}
